import React from "react";
import styles from './AdControlTopLine.module.scss';
import {IProduct} from 'data/interfaces/products';
import {MDBCol, MDBContainer, MDBNavbar, MDBRow} from 'mdbreact';
import AdStatus from "gui/components/listPage/components/ad/components/adStatus/AdStatus";
import {When} from 'react-if';

import EditorButtons from './components/editorButtons';
import ApproveOrDenyButtons from './components/approveDenyButtons';

export interface IAdControlTopLine {
  product: IProduct;
  isProductOwner: boolean;
  isOrderOwner: boolean;
  nextEditorRef?: any;
}


const AdControlTopLine = (props: IAdControlTopLine) => (
  <When condition={!!props.isProductOwner}>
    <MDBNavbar light tag="header" className={`${styles.AdControlTopLine} ${styles.topWhiteTitle}`}>
      <MDBContainer>
        <MDBRow className={styles.row}>
          <MDBCol className={styles.statusColumn} xs="12" md="5" lg="6">
            <AdStatus statusStyle={{margin: 0}} product={props.product}/>
          </MDBCol>
          <MDBCol className={styles.statusColumn} xs="12" md="7" lg="6">
            <EditorButtons {...props}/>
            <ApproveOrDenyButtons {...props}/>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </MDBNavbar>
  </When>
);

AdControlTopLine.defaultProps = {
  product: {},
};

export default AdControlTopLine;
